import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#checkbox-group" }),
  /*#__PURE__*/_createTextVNode(" Checkbox group ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " It is used for multiple checkboxes which are bound in one group, and indicates whether one option is selected by checking if it is checked. ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_checkbox_group, {
        modelValue: _ctx.checkList,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkList = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_checkbox, { label: "Option A" }),
          _createVNode(_component_el_checkbox, { label: "Option B" }),
          _createVNode(_component_el_checkbox, { label: "Option C" }),
          _createVNode(_component_el_checkbox, {
            label: "disabled",
            disabled: ""
          }),
          _createVNode(_component_el_checkbox, {
            label: "selected and disabled",
            disabled: ""
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code2), 1)
        ]),
        _: 1
      })
    ])
  ]))
}